import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

import rootReducer from "./rootReducer";

export default (preloadedState?: any) => {
  const middlewares = [thunk];
  const middlewareEnhancer = applyMiddleware(...middlewares);
  const composedEnhancers = composeWithDevTools({ serialize: true })(middlewareEnhancer);

  const store = createStore(rootReducer, preloadedState, composedEnhancers);
  window.onbeforeunload = function () {
    localStorage.setItem("store", JSON.stringify(store.getState()));
  };
  return store;
};
